import * as z from "zod";
import { gql } from "graphql-request";
import { ImageSchema, ImageFragment } from "../image";
import { SysSchema, SysFragment } from "../sys";
import { UnifiedButtonSchema, UnifiedButtonFragment } from "../unifiedButton";

export const LocalizedSpotlightSchema = z.object({
  __typename: z.literal("LocalizedSpotlight"),
  sys: SysSchema,
  title: z.string().nullable(),
  image: ImageSchema.nullable(),
  imageEn: ImageSchema.nullable(),
  buttonsCollection: z
    .object({
      items: z.array(UnifiedButtonSchema).nullish(),
    })
    .nullish(),
});

export const LocalizedSpotlight = LocalizedSpotlightSchema;
export type LocalizedSpotlight = z.infer<typeof LocalizedSpotlightSchema>;

export const LocalizedSpotlightFragment = gql`
  fragment LocalizedSpotlightFragment on LocalizedSpotlight {
    __typename
    sys {
      ...SysFragment
    }
    title
    image {
      ...ImageFragment
    }
    imageEn: image(locale: "en") {
      ...ImageFragment
    }
    buttonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }
  }
  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
`;
